import { InvitedUser, ParsedUser } from './types';

const parseUser = (data: InvitedUser): ParsedUser => ({
  fio: data!.user_fio || 'Без имени',
  id: data!.user_id || '',
});

export default parseUser;



// WEBPACK FOOTER //
// ./src/services/invite/utils/parseUsers.ts